import { Route, Routes, HashRouter as Router } from 'react-router-dom'

import Admin from '.'
import Dashboard from './packs/Dashboard'
import NewsDesk from './packs/NewsDesk'
import SystemManager from './packs/SystemManager'

const AdminRoutes = () => (
  <Router>
    <Admin>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/newsDesk/*" element={<NewsDesk />} />
        <Route path="/systemManager/*" element={<SystemManager />} />
      </Routes>
    </Admin>
  </Router>
)

export default AdminRoutes
